module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/couponGift-7051b0b8400854a57528baddaaefebc8.png";